
    /**
     * @description
     *  Clase de soporte con métodos útiles para manipular tipos enum.
     */

export class Enum {

    private constructor() {
        throw new Error(
            "Nunca debe instanciar o heredar de esta clase (es de soporte).");
    }

    /**
     * @description
     *  Convierte un string en una instancia de un enum, donde el valor del
     *  enum está representado por dicha cadena.
     *
     * @param type
     *  El tipo del enum.
     * @param name
     *  El nombre de algún campo del enum indicado en 'type'.
     *
     * @returns
     *  Una instancia del enum 'type'.
     */
    public static fromString<T>(type: T, name: string): any {
        return type[name];
    }

    /**
     * @description
     *  Convierte a string una instancia de algún enum.
     *
     * @param type
     *  El tipo del enum.
     * @param value
     *  Alguno de los posibles valores que puede tomar dicho enum.
     *
     * @returns
     *  La cadena que representa el valor del enum especificado.
     */
    public static toString<T, V>(type: T, value: V): string {
        return type[value.toString()];
    }

	/**
	 * @description
	 *	Obtiene la lista de valores de un enumerado. Opcionalmente permite
	 *	especificar el tipo de esta lista, ya que algunos enumerados utilizan
	 *	claves numéricas (lo más usual), mientras que otros se comportan como
	 *	cadenas de texto, por ejemplo.
	 *
	 * @param type
	 *	El tipo del enumerado del cual obtener sus valores posibles.
	 * @param keyType
	 *	El tipo de los valores, o "number" por defecto.
	 *
	 * @returns
	 *	Un vector con la lista de valores de este enum.
	 *
	 * @example
	 *	Un ejemplo básico de uso es el siguiente:
	 *
	 *		public paymentTypes: PaymentType[] = Enum.valuesOf(PaymentType);
	 *
	 *	En este caso, la variable "paymentTypes" contendrá todos los valores
	 *	posibles del enumerado, con lo cual luego se puede iterar por todos
	 *	ellos, por ejemplo, para crear un control de tipo "select":
	 *
	 *		...
	 *		<mat-select formControlName="movementType">
	 *			<mat-option></mat-option>
	 *			<mat-option *ngFor="let paymentType of paymentTypes" [value]="paymentType">
	 *				{{ toMovementTypeString(paymentType) }}
	 *			</mat-option>
	 *		</mat-select>
	 *		...
	 */
	public static valuesOf<T>(type: T, keyType: string = "number"): any[] {
		return Object.values(type)
			.filter(value => typeof value === keyType);
    }
}
